"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sandwichIds = void 0;
var sandwichIds = {
    planPage: {
        page: 'oep-plan-page',
        intro: 'oep-plan-intro',
    },
};
exports.sandwichIds = sandwichIds;
